/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageDataCommissionPartnerPageItemVo } from './PageDataCommissionPartnerPageItemVo';
import {
    PageDataCommissionPartnerPageItemVoFromJSON,
    PageDataCommissionPartnerPageItemVoFromJSONTyped,
    PageDataCommissionPartnerPageItemVoToJSON,
    PageDataCommissionPartnerPageItemVoToJSONTyped,
} from './PageDataCommissionPartnerPageItemVo';

/**
 * 
 * @export
 * @interface ResponsePageDataCommissionPartnerPageItemVo
 */
export interface ResponsePageDataCommissionPartnerPageItemVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePageDataCommissionPartnerPageItemVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePageDataCommissionPartnerPageItemVo
     */
    message?: string;
    /**
     * 
     * @type {PageDataCommissionPartnerPageItemVo}
     * @memberof ResponsePageDataCommissionPartnerPageItemVo
     */
    data?: PageDataCommissionPartnerPageItemVo;
}

/**
 * Check if a given object implements the ResponsePageDataCommissionPartnerPageItemVo interface.
 */
export function instanceOfResponsePageDataCommissionPartnerPageItemVo(value: object): value is ResponsePageDataCommissionPartnerPageItemVo {
    return true;
}

export function ResponsePageDataCommissionPartnerPageItemVoFromJSON(json: any): ResponsePageDataCommissionPartnerPageItemVo {
    return ResponsePageDataCommissionPartnerPageItemVoFromJSONTyped(json, false);
}

export function ResponsePageDataCommissionPartnerPageItemVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePageDataCommissionPartnerPageItemVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PageDataCommissionPartnerPageItemVoFromJSON(json['data']),
    };
}

export function ResponsePageDataCommissionPartnerPageItemVoToJSON(json: any): ResponsePageDataCommissionPartnerPageItemVo {
    return ResponsePageDataCommissionPartnerPageItemVoToJSONTyped(json, false);
}

export function ResponsePageDataCommissionPartnerPageItemVoToJSONTyped(value?: ResponsePageDataCommissionPartnerPageItemVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PageDataCommissionPartnerPageItemVoToJSON(value['data']),
    };
}

